import { render, staticRenderFns } from "./ManagePotSize.vue?vue&type=template&id=02b16f15&"
import script from "./ManagePotSize.vue?vue&type=script&lang=js&"
export * from "./ManagePotSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports